import { TableDataSource } from 'common/table/table-data-source';
import { ApiFinding, ApiV1FindingService } from 'api';
import { inject } from '@angular/core';
import { PagedResult, PageLoadParams } from 'common/table/paged-result.interface';
import { EMPTY, Observable } from 'rxjs';

export class FindingsDataSource extends TableDataSource<ApiFinding> {
  private readonly findingService = inject(ApiV1FindingService);

  private _reqApplicationId?: number;

  set reqApplicationId(value: number) {
    this._reqApplicationId = value;
  }

  protected fetchPage(pageLoadParams: PageLoadParams): Observable<PagedResult<ApiFinding>> {
    if (this._reqApplicationId === undefined) {
      return EMPTY;
    }

    const additionalParams = pageLoadParams.additionalParams || {};

    return this.findingService.getFindingsForRequirementApplication(
      this._reqApplicationId,
      pageLoadParams.page,
      pageLoadParams.pageSize,
      pageLoadParams.sortBy,
      pageLoadParams.sortDirection,
      additionalParams['filterText'],
      additionalParams['group'],
      additionalParams['kev'],
      additionalParams['severity'],
      additionalParams['status'],
    );
  }
}
